import {ExtractDeliveryNoteDocumentResult} from '@prompt-bridge/shared/validations';

import {Nullish} from 'shared/web';

import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

/**
 * Source values of a structured invoice are taken as they are. Tenant mappings (supplier, unit,
 * VAT) start empty so the user maps them explicitly instead of inheriting guessed defaults.
 */
export function mapStructuredInvoiceToDefaultValues(
  extractionId: string | Nullish,
  documentResult: ExtractDeliveryNoteDocumentResult | null
): DeliveryNoteDocumentPreviewFormDefinition {
  const basicInformation = {
    supplier: '',
    warehouse: '',
    deliveryNoteNumber: null,
    invoiceNumber: documentResult?.basicInformation?.invoiceNumber,
    authorizationProfile: '',
    paymentType: 'bank_transfer',
    currency: documentResult?.basicInformation?.currency || '',
  };

  const listOfItems =
    documentResult?.listOfItems?.flatMap((page) =>
      page.items.map((item) => ({
        sourceLineNumber: item.sourceLineNumber,
        isActive: true,
        isSelected: false,
        pageNumber: page.pageNumber,
        number: item.catalogueNumber || '',
        lastAutoFilledCatalogNumber: null,
        name: item.name || '',
        manufacturer: '',
        quantity: item.quantity,
        unit: null,
        vat: null,
        unitPrice: item.unitPrice,
        totalPrice: item.totalPrice,
      }))
    ) || [];

  return {
    extractionId,
    basicInformation,
    listOfItems,
  };
}
